/**
 *
 * ExerciseCourseCpnt
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';
import $ from 'jquery';

import Exercise from '@/scripts/Exercise';

export default {
  name: 'ExerciseCourseCpnt',

  mixins: [Exercise],

  data() {
    return {
      isDoneGetCourseAnalysis: false,
    };
  },

  computed: {
    ...mapState('MainModeCourse', {
      MainModeCourse_ms_isRequest: 'isRequest',
    }),

    ...mapGetters('Exercise', {
      Exercise_ms_isRequest: 'isRequest',
    }),

    c_isCpntRequest() {
      return (
        !this.MainModeCourse_ms_isRequest &&
        this.Exercise_ms_isRequest &&
        !this.isDoneGetCourseAnalysis
      );
    },

    c_isAvailable() {
      return this.CourseAnalysis.hasQuestionLib;
    },

    c_isUnpaid() {
      return !this.c_isAvailable;
    },
  },

  methods: {
    ...mapActions('MainModeCourse', {
      ma_getDiagnosisInfo: 'getDiagnosisInfo',
    }),

    getDiagnosisInfo() {
      this.ma_getDiagnosisInfo(this.$route.params.courseId);
    },

    async closeQuestionCpnt() {
      this.closeQuestion();
      this.getDiagnosisInfo();
      await this.getCourseAnalysis(this.courseId);
      this.updateDoughnutChart();
    },

    async _ExerciseCourseCpntMounted() {
      await this.promiseGetCourseAnalysis;
      this.isDoneGetCourseAnalysis = true;
    },
  },

  mounted() {
    this._ExerciseCourseCpntMounted();
  },

  beforeRouteLeave(to, from, next) {
    if (this.isShowQuestion) {
      $('.modal')
        .on('hidden.bs.modal', () => {
          setTimeout(() => {
            next();
          }, 0);
        })
        .modal('hide');
    } else {
      next();
    }
  },
};
